module.exports = __webpack_public_path__ + "static/foam-hand.aaac9c57.png";


//////////////////
// WEBPACK FOOTER
// ./assets/foam-hand.png
// module id = ./assets/foam-hand.png
// module chunks = 35783957827783 103038246049810